import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, SendDataToApi } from "@insite/client-framework/Store/Data/Carts/Handlers/AddCartLines";
import { dispatchAddToCartEvent } from "@store/Services/AnalyticsService";

addToChainAfter(chain, SendDataToApi, props => {
    const state = props.getState();
    
    /* Poolcorp Custom Code */
    const currentCurency = state.context.session.currency?.currencyCode;
    if (props.apiResult.cartLines) {
        dispatchAddToCartEvent(props.apiResult.cartLines, currentCurency);
    }
    /* Poolcorp Custom Code */
}); 
